module.exports = __webpack_public_path__ + "img/oval@3x.bb234768.png";